import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Engtranslation from "../src/locales/en/translation.json";
import Pltranslation from "../src/locales/pl/translation.json";
const resources = {
  en: { translation: Engtranslation },
  pl: { translation: Pltranslation },
};

const lang = localStorage.getItem("Lang") || "en";

i18n.use(initReactI18next).init({
  resources,
  lng: lang,
  fallbackLng: lang,
  interpolation: {
    escapeValue: false,
  },
});
export default i18n;
